import React, { useMemo, useCallback, useState } from 'react'
import {
  Navbar,
  Icon,
  IconName,
  Classes,
  Button,
  OverflowList,
  Boundary,
  Menu,
  Tag,
  Switch,
  AnchorButton,
  ButtonGroup,
} from '@blueprintjs/core'
import { Popover2, Tooltip2 } from '@blueprintjs/popover2'
import {
  Box,
  quarks,
  Stack,
  Text,
  useDarkMode,
} from 'ui-components'
import { NavLink, Link } from 'react-router-dom'
import 
  useSession
 from 'ui-io/use-session'
import moment from 'moment'
// import { useQuery } from 'react-query'

import { formatLocation } from '../routes'
import getDefaultReviewProps from '../pages/review/get-default-props'
// import RadarIcon from './radar-icon'
// import createRadarURL from '../utils/create-radar-url'
import SearchConfig from './search-config'
import useEffectRegularly from './use-effect-regularly'
//import IngestReport from './ingest-report'
//import IngestSummaryQuery from './ingest-summary-query'
//import { IngestEnvType } from './ingest-report-response-io'

type LinkType = {
  id: string
  title: string
  icon: IconName
  url: string
  envs?: string[]
}

const HOUR_MILLISECONDS = 1000 * 60 * 60

const makeLinks = (): LinkType[] => [
  {
    id: 'tasks',
    title: 'Tasks',
    icon: 'projects',
    url: formatLocation.taskInbox({}),
  },
  {
    id: 'review',
    title: 'Review',
    icon: 'resolve',
    url: formatLocation.review(getDefaultReviewProps()),
  },
  {
    id: 'analytics',
    title: 'Analytics',
    icon: 'grouped-bar-chart',
    url: formatLocation.analytics({}),
  },
    {
    id: 'configurations',
    title: 'Configurations',
    icon: 'git-repo',
    url: formatLocation.configurationCreate({}),
  },

]

const AppHeader = () => {
  const [darkMode, setDarkMode] = useDarkMode()
//   const { environment } = useSessionState()
const environment = "development"
  const session = useSession()

  const [links, setLinks] = useState<LinkType[]>(() => makeLinks())
  /* const [showIngestDialogue, toggleIngestDialogue] = useToggle(false)
  const [ingestEnvironment, setIngestEnvironment] =
    useState<IngestEnvType>('Prod') */

  useEffectRegularly(
    () => setLinks(makeLinks()),
    HOUR_MILLISECONDS,
    moment().startOf('hour').add(1, 'hour').toDate(),
  )

  const items = useMemo(() => {
    return links.filter(({ envs }) => {
      if (!envs) return true
      return envs.includes(environment)
    })
  }, [links, environment])

  const visibleItemRendered = useCallback(
    ({ id, url, icon, title }: LinkType) => {
      return (
        <NavLink
          key={id}
          to={url}
          className={({ isActive }) =>
            `${Classes.BUTTON} ${Classes.MINIMAL}${isActive ? ` ${Classes.INTENT_PRIMARY}` : ''}`
          }
        >
          <Box flexDir="row" items="center">
            <Icon
              icon={icon}
              style={{ marginRight: quarks.margins.small }}
              iconSize={14}
            />
            <span>{title}</span>
          </Box>
        </NavLink>
      )
    },
    [],
  )

  const overflowRendered = useCallback(
    (items: LinkType[]) => {
      return (
        <span style={{ alignSelf: 'center' }}>
          <Popover2 content={<Menu>{items.map(visibleItemRendered)}</Menu>}>
            <Button icon="more" small minimal />
          </Popover2>
        </span>
      )
    },
    [visibleItemRendered],
  )


  return (
    <>
     
      <Navbar fixedToTop>
        <Navbar.Group style={{ width: '100%' }}>
          <Navbar.Heading>
            <Box items="center">
              <span style={{ fontWeight: quarks.fontWeights.bold }}>Harbour</span>
              {/* {environment !== 'prod' && (
                <Tag
                  minimal
                  intent="primary"
                  style={{ marginLeft: quarks.margins.small }}
                >
                  {environment}
                </Tag>
              )} */}
            </Box>
          </Navbar.Heading>
          <Navbar.Divider />
          <OverflowList
            items={items}
            collapseFrom={Boundary.END}
            overflowRenderer={overflowRendered}
            visibleItemRenderer={visibleItemRendered}
            observeParents={true}
          />
          <Box
            flexDir="row"
            items="center"
            pl="large"
            style={{ marginLeft: 'auto' }}
          >
            <SearchConfig />
            <Switch
              style={{ marginBottom: 0 }}
              innerLabelChecked="🌙"
              innerLabel="☀️"
              checked={darkMode}
              onChange={() => setDarkMode((prev) => !prev)}
            />
            <ButtonGroup>
              {/* Hiding the ingest report for time being */}
              {/* <Tooltip2 content={IngestTooltipContent}>
                <Button
                  icon={getIcon(prodIntent)}
                  minimal
                  onClick={toggleIngestDialogue}
                  intent={prodIntent}
                />
              </Tooltip2> */}
              {/* <Tooltip2 content="File a radar">
                <AnchorButton
                  icon={<RadarIcon />}
                  minimal
                  href={createRadarURL({})}
                />
              </Tooltip2> */}
              <Popover2
                content={
                  <Box p="medium">
                    <Stack>
                    
                      <Box>
                        <Text muted caption mb="xsmall">
                          Frontend
                        </Text>
                        V1
                      </Box>
                      
                    </Stack>
                  </Box>
                }
              >
                <Tooltip2 content="Application information">
                  <Button icon="application" minimal />
                </Tooltip2>
              </Popover2>
              <Tooltip2 content="Log out">
                <Button
                  icon="log-out"
                  onClick={() => session.logout()}
                  minimal
                />
              </Tooltip2>
            </ButtonGroup>
          </Box>
        </Navbar.Group>
      </Navbar>
    </>
  )
}

export default AppHeader
